
































































































































































































































































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import { IPaymentMethod, ITagsGroup } from '@/interfaces';
import { dispatchGetAvailablePaymentMethods, dispatchGetTagsGroupsFields } from '@/store/main/actions';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import { dispatchGetMyStructureContactsChoices } from '@/store/team/actions';
import moment from 'moment';
import { getWZFilters, saveWZFilters } from '@/utils';

@Component({
  components: {
    FmvAvatar,
    Datetime,
    Multiselect,
    CustomSelectInput,
    // MdIcon,
  },
})
export default class WorkZoneFilters extends Vue {
  // @ts-ignore
  @Prop({required: true}) readonly public showFilters: boolean;
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public loadingState: boolean;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public employee: number | null;
  // // @ts-ignore
  // @Prop({required: true, default: null}) readonly public lead: any;
  // public tasksList: IContactTasksRow[] = [];
  
  public tagsGroups: ITagsGroup[] = [];
  public paymentMethods: IPaymentMethod[] = [];
  public contactsChoices: any = {
    choices: [],
  };
  public filters: any = {
    period: 'quarter',
    range_from: '',
    range_to: '',
    employees: [],
    contacts: [],
    dateBirth: '',
    today_birthday: '',
    donationTypes: [],
    sow: 'yes',
    notSow: 'no',
    paymentMethod: [],
    country: [],
    tasks: '',
    isPartner: '',
    languages: [],
    tagsGroupsFields: {},
  };

  public async mounted() {
    const filters: any = getWZFilters(this.employee);
    if (filters && filters !== 'undefined' && filters !== 'null') {
      this.filters = {...JSON.parse(filters)};
    } else {
      if (this.employee) {
        this.filters.employees.push(this.employee);
      }
    }
    this.tagsGroups = await dispatchGetTagsGroupsFields(this.$store);
    this.paymentMethods = await dispatchGetAvailablePaymentMethods(this.$store, {});
    this.contactsChoices = await dispatchGetMyStructureContactsChoices(
      this.$store, { rowQuery: `?employees=${JSON.stringify(this.filters.employees)}`},
    );

    let newTagsGroupsFields = {};
    for (let i in this.tagsGroups) {
      if (this.tagsGroups[i].id in this.filters.tagsGroupsFields) {
        newTagsGroupsFields[this.tagsGroups[i].id] = this.filters.tagsGroupsFields[this.tagsGroups[i].id];
      } else {
        newTagsGroupsFields[this.tagsGroups[i].id] = [];
      }
    }
    this.filters.tagsGroupsFields = newTagsGroupsFields;
    this.handleSubmit();
  }

  public handleSubmit() {
    let rowQuery = `&period=${this.filters.period}`+
    `&range_from=${this.filters.range_from}`+
    `&range_to=${this.filters.range_to}`+
    `&employees=${JSON.stringify(this.filters.employees)}`+
    `&contacts=${JSON.stringify(this.filters.contacts)}`+
    `&date_birth=${this.filters.dateBirth}`+
    `&today_birthday=${this.filters.today_birthday}`+
    `&donation_types=${JSON.stringify(this.filters.donationTypes)}`+
    `&sow=${this.filters.sow}`+
    `&not_sow=${this.filters.notSow}`+
    `&payment_method=${JSON.stringify(this.filters.paymentMethod)}`+
    `&country=${JSON.stringify(this.filters.country)}`+
    `&tasks=${this.filters.tasks}`+
    `&is_partner=${this.filters.isPartner}`+
    `&languages=${JSON.stringify(this.filters.languages)}`;

    for (const [key, value] of Object.entries(this.filters.tagsGroupsFields)) {
      rowQuery += `&tag_groups_${key}=${JSON.stringify(value)}`;
    }
    saveWZFilters(this.employee, JSON.stringify(this.filters));
    this.$emit('submit-filters', rowQuery);
  }

  public resetFilters() {
    this.filters = {
      period: 'quarter',
      range_from: '',
      range_to: '',
      employees: [],
      contacts: [],
      dateBirth: '',
      today_birthday: '',
      donationTypes: [],
      paymentMethod: [],
      sow: 'yes',
      notSow: 'no',
      country: [],
      tasks: '',
      isPartner: '',
      languages: [],
      tagsGroupsFields: {},
    };
    this.handleSubmit();
  }

  public async handleChangeEmployee(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.employees = newList;
    this.filters.contacts = [];
    this.contactsChoices = await dispatchGetMyStructureContactsChoices(
      this.$store, { rowQuery: `?employees=${JSON.stringify(this.filters.employees)}`},
    );
  }

  public handleChangeContacts(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.contacts = newList;
  }

  public handleChangeCategory(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.donationTypes = newList;
  }

  public handleChangeCountry(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.country = newList;
  }

  public handleChangeLanguages(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.languages = newList;
  }

  get languagesChoices() {
    return [
      {id: 'ru', name: this.$t('Russian')},
      {id: 'en', name: this.$t('English')},
    ];
  }

  get languagesMultipleValue() {
    const newList: any = [];
    for (const [key, value] of Object.entries(this.languagesChoices)) {
      if (this.filters.languages.includes(value.id)) {
        newList.push({
          id: value.id,
          name: value.name,
        });
      }
    }
    return newList;
  }

  public fieldValue(field) {
    const newList: any = [];
    for (const [key, value] of Object.entries(field.tags)) {
      // @ts-ignore
      if (this.filters.tagsGroupsFields[field.id].includes(value.id)) {
        newList.push(value);
      }
    }
    return newList;
  }

  public handleChangeField(field, value) {
    console.log(field, value);
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.tagsGroupsFields[field.id] = newList;
    this.filters = {...this.filters};
  }

  get contactsMultipleValue() {
    const newList: any = [];
    for (const [key, value] of Object.entries(this.contactsList)) {
      // @ts-ignore
      if (this.filters.contacts.includes(value.id)) {
        newList.push({
          // @ts-ignore
          id: value.id, name: value.name,
        });
      }
    }
    return newList;
  }

  get payMethods() {
    const payMethods: any = [];
    if (this.paymentMethods) {
      for (const [key, value] of Object.entries(this.paymentMethods)) {
        payMethods.push({
          id: value.id, name: value.title,
        });
      }
    }
    return payMethods;
  }

  public handleChangePaymentMethod(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.filters.paymentMethod = newList;
  }

  get payMethodsMultipleValue() {
    const newList: any = [];
    for (const [key, value] of Object.entries(this.payMethods)) {
      // @ts-ignore
      if (this.filters.paymentMethod.includes(value.id)) {
        newList.push({
          // @ts-ignore
          id: value.id, name: value.name,
        });
      }
    }
    return newList;
  }

  get contactsList() {
    const cashbackList: any = [];
    if (this.contactsChoices && this.contactsChoices.choices) {
      for (const [key, value] of Object.entries(this.contactsChoices.choices)) {
        // @ts-ignore
        if (value[0]) {
          cashbackList.push({
            // @ts-ignore
            id: value[0], name: value[1],
          });
        }
      }
    }
    return cashbackList;
  }

  public checkGroups(groups) {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

  public handleChangePeriod() {
    if (this.filters.period === 'range') {
      let date_today = new Date();
      let firstDay = new Date(date_today.getFullYear(), date_today.getMonth(), 1);
      // let lastDay = new Date(date_today.getFullYear(), date_today.getMonth() + 1, 0);
      this.filters.range_from = moment(String(firstDay)).format('YYYY-MM-DD');
      this.filters.range_to = moment(new Date()).format('YYYY-MM-DD');
    } else {
      this.filters.range_from = '';
      this.filters.range_to = '';
    }
  }

  public handleChangeRange(field: string) {
    if (field === 'range_from') {
      // @ts-ignore
      if (moment(this.filters.range_from)._d > moment(this.filters.range_to)._d) {
        this.filters.range_to = this.filters.range_from;
      }
    } else {
      // @ts-ignore
      if (moment(this.filters.range_to)._d < moment(this.filters.range_from)._d) {
        this.filters.range_from = this.filters.range_to;
      }
    }
    // @ts-ignore
    if (moment(this.filters.range_to)._d > new Date()) {
      setTimeout(()=>{
        this.filters.range_to = moment(new Date()).format('YYYY-MM-DD');
        this.handleChangeRange('range_to');
      }, 100);
      
    }
  }

  public closeModal() {
    this.$emit('close-modal');
  }
  
  get userProfile() {
    return readUserProfile(this.$store);
  }

  get calendarTranslates() {
    return {
      labelPrevDecade: this.$t('Previous decade'),
      labelPrevYear: this.$t('Previous year'),
      labelPrevMonth: this.$t('Previous month'),
      labelCurrentMonth: this.$t('Current month'),
      labelNextMonth: this.$t('Next month'),
      labelNextYear: this.$t('Next year'),
      labelNextDecade: this.$t('Next decade'),
      labelToday: this.$t('Today'),
      labelSelected: this.$t('Selected'),
      labelNoDateSelected: this.$t('No date selected'),
      labelCalendar: this.$t('Calendar'),
      labelNav: this.$t('Navigation'),
      labelHelp: this.$t('Use the arrow keys to navigate through the calendar'),
      labelCloseButton: this.$t('Close'),
      labelResetButton: this.$t('Reset'),
      labelTodayButton: this.$t('Today'),
    };
  }
}
